import React from 'react';
import styles from './LoadingSpinner.module.scss';

const LoadingSpinner = () => (
  <div className={styles.spinnerContainer} data-testid="kbyg-rewinds-loading-spinner">
    <div className={styles.loading} />
  </div>
);

export default LoadingSpinner;
